import { render, staticRenderFns } from "./ConsumeBitacora.vue?vue&type=template&id=5818a9a9&"
import script from "./ConsumeBitacora.vue?vue&type=script&lang=js&"
export * from "./ConsumeBitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports